import {Component, ChangeDetectionStrategy} from '@angular/core';
import {PermissionKeys} from '../app.constants';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertComponent {

    PermissionKeys = PermissionKeys;

    constructor() {}

}
